module.exports = "https://static.wmbcdn.com/uniweb/images/b3dbaba49db3eb76f1be4a32ebd286f2.svg";